import { KnownHubDtoType, TowerDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { SVGIconComponent } from '../../../ui/components/pure/icons/types';
import { Tower } from './tower.model';
import { LockerDetails } from './locker-details.model';

export class TowerDetails extends Tower {
  public readonly lockers: LockerDetails[];

  constructor(tower: TowerDto, lockers: LockerDetails[], hubType: KnownHubDtoType) {
    super(tower, hubType);
    this.lockers = lockers;
  }
  get lockersCount() {
    return this.lockers.length;
  }
  get lockersCountDescription() {
    const lockersWord = this.lockersCount === 1 ? 'locker' : 'lockers';
    return `${this.lockersCount} ${lockersWord}`;
  }

  get lockersCountBySize() {
    return this.lockers.reduce((acc, locker) => {
      if (locker.isKiosk) {
        acc['kiosk'] = {
          count: 1,
          Icon: locker.sizeIcon
        };
        return acc;
      }
      const size = locker.sizeName;
      if (acc[size]) {
        acc[size].count++;
      } else {
        acc[size] = {
          count: 1,
          Icon: locker.sizeIcon
        };
      }
      return acc;
    }, {} as Record<string, { Icon: SVGIconComponent; count: number }>);
  }
}
